import { Component, EventEmitter, Input, Output, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormGroup, FormGroupDirective, FormArray, Validators, UntypedFormBuilder, FormGroup } from '@angular/forms';
import { DisplayMode } from 'cbc-shared-lib';
import { ActivatedRoute, Router } from '@angular/router';
import { TankatableMeisaiDto, TankatableregistrationManageInfo } from 'sg-api';
import { MoneyFormatService } from '../../../../../../sg-base/sg-base-shared/services/money-format.service'

/**単価表登録画面 （単価情報）
 * @export
 * @class Sgkc012dTankaTableTankaInfoComponent
 * @implements {OnInit,OnDestroy} 
 */
@Component({
    selector: 'app-sgkc012d-tanka-table-tanka-info',
    templateUrl: './sgkc012d-tanka-table-tanka-info.component.html',
    styleUrl: './sgkc012d-tanka-table-tanka-info.component.scss',
})
export class Sgkc012dTankaTableTankaInfoComponent implements OnInit, OnDestroy {

    /** 親コンポーネント保持領域 */
    parentForm: UntypedFormGroup;
    // 画面表示モード
    @Input() mode: string
    // 単価表登録管理情報
    @Input() tankatableregistrationManageInfo: TankatableregistrationManageInfo;
    // 単価表明細情報
    @Input() tankatableMeisaiList: TankatableMeisaiDto[];
    /** 登録ボタン押下イベント */
    @Output() onClickRegistrationEvent = new EventEmitter<void>();
    /** 取消ボタン押下イベント */
    @Output() onClickDeleteEvent = new EventEmitter<void>();
    /** 承認ボタン押下イベント */
    @Output() onClickApprovalEvent = new EventEmitter<void>();

    /** 適用開始年月 */
    applyStartyearmonth = this.fb.control({ value: '', disabled: true }, Validators.required);
    /** 適用終了年月 */
    applyEndyearmonth = this.fb.control({ value: '', disabled: true });
    /** 単価表情報Form */
    tankatableMeisaiInfoForm: UntypedFormGroup = this.fb.group({
        applyStartyearmonth: this.applyStartyearmonth,
        applyEndyearmonth: this.applyEndyearmonth,
        items: this.fb.array([]),
    })

    /** 単価の最大桁数 */
    readonly constNumberCommaMaxLength: number = 10;
    numberCommaMaxLength: number = this.constNumberCommaMaxLength;
    /** 登録ボタン表示フラグFormGroup */
    isRegistVisible: boolean = false;
    /** 取消ボタン表示フラグFormGroup */
    isDeleteVisible: boolean = false;
    /** 承認ボタン表示フラグFormGroup */
    isApproveVisible: boolean = false;

    /**
     * コンストラクタ
     * @param {Router} router
     * @param {FormGroupDirective} parent
     * @param {UntypedFormBuilder} fb
     * @param {MoneyFormatService} moneyFormatServiceService
     * @param {ActivatedRoute} route
     * @memberof Sgkc012dTankaTableTankaInfoComponent
     */
    constructor(
        private router: Router,
        private parent: FormGroupDirective,
        private fb: UntypedFormBuilder,
        private moneyFormatServiceService: MoneyFormatService,
        private route: ActivatedRoute,
    ) {
    }

    /** 
     * 初期処理
     * @memberof Sgkc012dTankaTableTankaInfoComponent
     */
    ngOnInit(): void {
        this.tankatableMeisaiInfoForm.controls['applyEndyearmonth'].setValue(this.tankatableregistrationManageInfo.applyEndDate.substring(0, 6));
        // 単価の件数分、itemsに追加
        const itemsList = this.tankatableMeisaiInfoForm.get('items') as FormArray;
        if (this.mode === DisplayMode.create) {
            this.tankatableMeisaiList.forEach((tankaDetail) => {
                itemsList.push(this.fb.group({
                    tankaAname: [{ value: tankaDetail.tankaAname, disabled: true }],
                    tankaRangeStart: [{ value: tankaDetail.tankaRangeStart, disabled: true }],
                    unitPriceRangeEnd: [{ value: tankaDetail.unitPriceRangeEnd, disabled: true }],
                    tanka: [{ value: "", disabled: true }, Validators.required],
                    updateSrno: [{ value: tankaDetail.updateSrno, disabled: true }],
                    prdCode: [{ value: tankaDetail.prdCode, disabled: true }],
                    goodsCode: [{ value: tankaDetail.goodsCode, disabled: true }],
                    chargeCode: [{ value: tankaDetail.chargeCode, disabled: true }],
                    tankaSiteiDiv1: [{ value: tankaDetail.tankaSiteiDiv1, disabled: true }],
                    tankaSiteiDiv2: [{ value: tankaDetail.tankaSiteiDiv2, disabled: true }],
                    tankaSiteiDiv3: [{ value: tankaDetail.tankaSiteiDiv3, disabled: true }],
                    tankaSiteiDiv4: [{ value: tankaDetail.tankaSiteiDiv4, disabled: true }],
                    tankaSiteiDiv5: [{ value: tankaDetail.tankaSiteiDiv5, disabled: true }],
                    applyStartDate: [{ value: tankaDetail.applyStartDate, disabled: true }],
                    applyEndDate: [{ value: tankaDetail.applyEndDate, disabled: true }],
                    tankaRyaku: [{ value: tankaDetail.tankaRyaku, disabled: true }],
                    choseiTankaCode: [{ value: tankaDetail.choseiTankaCode, disabled: true }],
                    unit: [{ value: tankaDetail.unit, disabled: true }],
                    exceedUnitPrice: [{ value: tankaDetail.exceedUnitPrice, disabled: true }],
                    exceedUnit: [{ value: tankaDetail.exceedUnit, disabled: true }],
                    displayTankaRangeStart: [{ value: this.truncateToOneDecimal(tankaDetail.tankaRangeStart), disabled: true }],
                    displayUnitPriceRangeEnd: [{ value: this.truncateToOneDecimal(tankaDetail.unitPriceRangeEnd), disabled: true }],
                }));
            });
        } else {
            this.tankatableMeisaiInfoForm.controls['applyStartyearmonth'].setValue(this.tankatableregistrationManageInfo.applyStartDate.substring(0, 4) + '-' + this.tankatableregistrationManageInfo.applyStartDate.substring(4, 6));
            this.tankatableMeisaiList.forEach((tankaDetail) => {
                itemsList.push(this.fb.group({
                    tankaAname: [{ value: tankaDetail.tankaAname, disabled: true }],
                    tankaRangeStart: [{ value: tankaDetail.tankaRangeStart, disabled: true }],
                    unitPriceRangeEnd: [{ value: tankaDetail.unitPriceRangeEnd, disabled: true }],
                    tanka: [{ value: this.moneyFormatServiceService.formatMoney(tankaDetail.tanka.toFixed(2)), disabled: true }, Validators.required],
                    updateSrno: [{ value: tankaDetail.updateSrno, disabled: true }],
                    prdCode: [{ value: tankaDetail.prdCode, disabled: true }],
                    goodsCode: [{ value: tankaDetail.goodsCode, disabled: true }],
                    chargeCode: [{ value: tankaDetail.chargeCode, disabled: true }],
                    tankaSiteiDiv1: [{ value: tankaDetail.tankaSiteiDiv1, disabled: true }],
                    tankaSiteiDiv2: [{ value: tankaDetail.tankaSiteiDiv2, disabled: true }],
                    tankaSiteiDiv3: [{ value: tankaDetail.tankaSiteiDiv3, disabled: true }],
                    tankaSiteiDiv4: [{ value: tankaDetail.tankaSiteiDiv4, disabled: true }],
                    tankaSiteiDiv5: [{ value: tankaDetail.tankaSiteiDiv5, disabled: true }],
                    applyStartDate: [{ value: tankaDetail.applyStartDate, disabled: true }],
                    applyEndDate: [{ value: tankaDetail.applyEndDate, disabled: true }],
                    tankaRyaku: [{ value: tankaDetail.tankaRyaku, disabled: true }],
                    choseiTankaCode: [{ value: tankaDetail.choseiTankaCode, disabled: true }],
                    unit: [{ value: tankaDetail.unit, disabled: true }],
                    exceedUnitPrice: [{ value: tankaDetail.exceedUnitPrice, disabled: true }],
                    exceedUnit: [{ value: tankaDetail.exceedUnit, disabled: true }],
                    displayTankaRangeStart: [{ value: this.truncateToOneDecimal(tankaDetail.tankaRangeStart), disabled: true }],
                    displayUnitPriceRangeEnd: [{ value: this.truncateToOneDecimal(tankaDetail.unitPriceRangeEnd), disabled: true }],
                }));
            });
        }

        this.parentForm = this.parent.form;
        this.parentForm.addControl('tankatableMeisaiInfoForm', this.tankatableMeisaiInfoForm);
        // フォームの活性制御、登録のとき適用開始年月と単価を活性
        if (this.mode === DisplayMode.create) {
            this.tankatableMeisaiInfoForm.get('applyStartyearmonth').enable();
            const itemsList = this.tankatableMeisaiInfoForm.get('items') as FormArray;
            itemsList.controls.forEach((item: FormGroup) => {
                item.controls['tanka'].enable();
            });
            this.isRegistVisible = true;
        } else if (this.mode === DisplayMode.delete) {
            this.isDeleteVisible = true;
        } else if (this.mode === DisplayMode.approve) {
            this.isApproveVisible = true;
        }
    }

    /** 
     * 変更を停止する処理
     * @memberof Sgkc012dTankaTableTankaInfoComponent
     */
    ngOnDestroy(): void {
        if (this.parent.form != null) {
            this.parentForm.clearValidators();
            this.parentForm.updateValueAndValidity();
            // 親画面のFormGroupからコントロールを削除
            this.parent.form.removeControl('tankatableMeisaiInfoForm');
        }
    }

    /** 
     * フォーカスアウト時のカンマ編集
     * 小数点以下が2桁以下のとき2桁まで0を追加それ以上のときそのままの値でカンマを付与
     * @param {FocusEvent} event
     * @param {number} index
     */
    onBlurNumberComma(event: FocusEvent, index: number): void {
        const inputElement = event.target as HTMLInputElement;
        const controlName = inputElement.getAttribute('formControlName');
        // 画面入力項目を取得、前後の空白を削除
        let targetMoney = this.items.at(index).get(controlName)?.value.trim();
        if (targetMoney) {
            // カンマを除去
            let reformatnumerTransValue: string = targetMoney.replace(/,/g, '');
            let numerTransValue = Number(reformatnumerTransValue);
            // 数値のとき処理を実行
            if (!isNaN(numerTransValue)) {
                // 小数点以下の桁数を取得
                let decimalPlaces = (reformatnumerTransValue.split('.')[1] || '').length;
                // 小数点以下が2桁以下のとき2桁まで表示、それ以上のときそのまま表示
                if (decimalPlaces <= 2) {
                    targetMoney = numerTransValue.toFixed(2);
                } else {
                    targetMoney = reformatnumerTransValue;
                }
            }
        }
        let commaMoney: string = this.moneyFormatServiceService.formatMoney(targetMoney);
        // カンマの数取得
        let commaArray: string[] = commaMoney.match(/,/g);
        let commaCount: number = 0;
        if (commaArray != null) {
            commaCount = commaArray.length
        }
        // カンマの数と元々の最大桁数をmaxlengthに設定
        this.numberCommaMaxLength = this.constNumberCommaMaxLength + commaCount;
        setTimeout(() => {
            this.items.at(index).get(controlName)?.setValue(commaMoney);
        }, 1);
    }

    /** 
     * フォーカスイン時のカンマ編集
     * 入力値からカンマを除去
     * @param {FocusEvent} event
     * @param {number} index
     */
    onFocusNumberComma(event: FocusEvent, index: number): void {
        const inputElement = event.target as HTMLInputElement;
        const controlName = inputElement.getAttribute('formControlName');
        let targetMoney: string = this.items.at(index).get(controlName)?.value;
        let noCommatMoney: string = targetMoney.replace(/,/g, '');
        this.numberCommaMaxLength = this.constNumberCommaMaxLength;
        this.items.at(index).get(controlName)?.setValue(noCommatMoney);
    }

    /** 
     * 戻るボタン押下時の処理
     * @memberof Sgkc012dTankaTableTankaInfoComponent
     */
    goToPrevious(): void {
        this.router.navigate(['/sgkc/sgkc021d', {
            mode: this.route.snapshot.paramMap.get('backmode'),// 戻るボタン用画面モード
        }])
    }

    /** 
     * 登録ボタン押下時の処理
     * @memberof Sgkc012dTankaTableTankaInfoComponent
     */
    onClickRegistration(): void {
        this.onClickRegistrationEvent.emit();
    }

    /** 
     * 取消ボタン押下時の処理
     * @memberof Sgkc012dTankaTableTankaInfoComponent
     */
    onClickApproval(): void {
        this.onClickApprovalEvent.emit();
    }

    /** 
     * 取消ボタン押下時の処理
     * @memberof Sgkc012dTankaTableTankaInfoComponent
     */
    onClickDelete(): void {
        this.onClickDeleteEvent.emit();
    }

    /** 
     * 単価表明細情報のFormArrayを取得
     * @returns {FormArray}
     */
    get items() {
        return this.tankatableMeisaiInfoForm.get('items') as FormArray;
    }

    /** 
     * 小数点以下1桁に切り捨て
     * @param {number} value
     * @returns {number}
     */
    private truncateToOneDecimal(value: number): number {
        return Math.floor(value * 10) / 10;
    }
}
